export const WELCOME_PHRASES_BY_LANG = {
  en: [
    'free location tracker',
    'track cell phone without permission',
    'locate an iphone free',
    'cell phone location lookup free',
    'phone locator free',
    'locate any phone by number',
    'track someone by cell phone number without them knowing',
    'find my iphone free',
    'track my cell phone free',
    'find my iphone apple',
    'google maps phone tracker',
    'free geolocation by phone number',
    'find my samsung free',
    'find my phone android',
    'free tracker app for android',
    'find my phone',
    'find my phone iphone',
    'find my android free',
    'how to track an iphone free',
    'gps location by phone number',
    'locate a phone free',
    'locate phone free',
    'life360 family locator free',
    'find my phone samsung',
    'locate a cell phone for free',
    'google find my device',
    'locate a phone by number free',
    'find my android phone free',
    'apple iphone find my phone',
    'locate a iphone for free',
  ],
  de: [
    'verlorenes handy orten kostenlos',
    'handy orten',
    'handy verloren orten kostenlos',
    'handyortung',
    'handy ortung kostenlos',
    'handy kostenlos orten',
    'handy orten kostenlos',
    'handy verloren orten',
    'handyortung google',
    'handy orten über google',
    'iphone orten kostenlos',
    'Kostenloser Handy Tracker',
    'verlorenes handy orten',
    'iphone verloren orten',
    'handynummer orten kostenlos',
    'samsung handy verloren orten',
    'handyortung iphone',
    'Wo ist mein Handy',
    'telefonortung kostenlos',
    'gps ortung kostenlos',
    'handy orten kostenlos google',
    'iphone orten',
    'Handy per Nummer orten',
    'Finde mein Handy kostenlos',
    'rufnummer ortung kostenlos',
  ],
  it: [
    'rintracciare un telefono',
    'spia gratis android',
    'localizzatore telefonico gratuito',
    'trovare la posizione del telefono',
    'Trova posizione cellulare gratis',
    'rintracciare il cellulare gratis',
    'trovare la posizione di qualcuno',
    'localizar móvil gratis por número',
    'trovare il mio iphone',
    'Trova il mio cellulare',
    'rintracciare la posizione',
    'migliore app spia',
    'rintracciare il numero di telefono',
    'app di localizzazione',
    'localizzatore di telefoni',
    'localizzare un cellulare gratis',
    'app spia segreta',
    'rintracciare telefono android',
    'google trova il mio dispositivo',
    'rastrear celular por número',
    'app localizzatore',
    'rintracciare la posizione di un cellulare gratis',
    'tracker del telefono',
    'trovare il mio telefono google',
    'localizzatore gps per auto',
  ],
  fr: [
    'espionner un autre téléphone',
    'localiser un numéro de téléphone',
    'localiser un téléphone',
    'localiser le téléphone',
    'trouver mon téléphone sur google',
    'localiser mon telephone',
    "localisation d'un téléphone",
    'retrouver mon iphone',
    "localisateur d'iphone",
    'comment localiser un numéro de téléphone',
    'localiser un téléphone android',
    'localiser mon téléphone',
    'localiser mon téléphone samsung',
    'localiser un telephone',
    'gps localisation de téléphone',
    'localisation téléphone',
    'localiser un numéro',
    'recherche par numéro téléphone',
    'trouver mon téléphone samsung',
    'retrouver mon téléphone samsung',
    'localiser un samsung gratuitement',
    'localiser par numéro de téléphone',
    'gps traceur application',
    'suivre le numéro de téléphone',
    'localiser un numero de cellulaire',
  ],
  es: [
    'como rastrear un celular',
    'rastrear celular',
    'rastrear móvil gratis',
    'localizar celular',
    'ubicar celular por número gratis',
    'rastrear número de teléfono gratis',
    'rastrear un celular apagado gratis',
    'encontrar mi dispositivo',
    'como localizar un celular apagado',
    'localizar celular gratis',
    'rastrear movil',
    'rastrear celular por gmail',
    'aplicación espía gratuita',
    'localizar un iPhone gratis',
    'como localizar un iphone perdido',
    'rastrear un teléfono gratis',
    'rastrear ubicación',
    'localizar número de teléfono gratis',
    'buscar mi iphone',
    'rastrear gps con numero de celular',
    'rastrear móvil perdido gratis',
    'ubicación de teléfonos gratis',
    'app espía gratis',
    'localizar mi telefono samsung',
    'rastrear el gps de un celular',
  ],
  zh: [
    '如何找回遺失的手機',
    '追蹤手機位置',
    '手機 遺失',
    '手機 遺失 定位',
    '免費定位手機位置',
    '追蹤手機 GPS',
    '我的手機',
    '免費手機號碼追蹤',
    'iphone 不見',
    '免費追蹤手機號碼',
    '如何追蹤手機位置',
    '手機定位',
    '尋找我的手機位置',
    '尋找我的 iPhone',
    '手機 不見 怎麼 辦',
    '找到遺失的手機',
    '手機 不見',
    '尋找我的 iPhone蘋果',
    'iPhone定位',
    '免費追蹤電話號碼',
    '尋找 iPhone 位置',
    '定位 iPhone',
    '如何定位別人的手機',
    '追蹤手機號碼位置',
    '如何追蹤手機',
    '追蹤iPhone',
    '追蹤電話號碼',
    '如何定位別人的iPhone',
    '追蹤手機號碼',
    '谷歌定位手機',
  ],
  ja: [
    'iPhoneを探す',
    'デバイスを探す',
    '紛失した携帯電話を見つける方法',
    'Google デバイスを探す',
    '携帯が見つからない',
    '紛失した携帯電話を探す',
    'デバイスを探す Android',
    '携帯電話が見つからない',
    '携帯電話の位置',
    'iPhoneを見つける方法',
    'iPhoneが見つからない',
    '友達のiPhoneを探す',
    '携帯電話の位置検索',
    'iPhoneで探す方法',
    '電話番号から位置検索',
    '電話番号で追跡',
    'Androidでデバイスを探す',
    'Android スマホを探す',
    'Googleデバイスを探す',
    '友達のiPhoneを探す方法',
    '電話番号の位置情報',
    'Androidのデバイスを探す',
    '紛失したスマホを探す',
    '電話番号で携帯電話を探す',
    'iPhoneを探す アップル',
    '携帯 紛失 探す 方法',
    'iPhoneで携帯電話を探す',
    '携帯電話の位置を特定する',
    '携帯電話を探す iPhone',
    'iPhoneデバイスを探す',
  ],
} as const;
